import { NestAPI } from '@marketing-milk/frontend'
import { AdMediaPage, AdMediaType } from '@marketing-milk/interfaces'

export interface MediaLibraryQuery {
  mediaType?: AdMediaType
  search: string
  offset: number
}

/**
 * A business's stored images and videos, as the editor's library browses them.
 * A capability like `onUploadMedia` beside it, so the editor never learns which
 * business it is in.
 */
export interface MediaLibrary {
  list: (query: MediaLibraryQuery) => Promise<AdMediaPage>
  /** Also removes the image from the business's Facebook ad account. */
  deleteImage: (imageID: number) => Promise<void>
}

export const reviewMediaLibrary = (businessID: number): MediaLibrary => ({
  list: async ({ mediaType, search, offset }) => {
    const response = await NestAPI.get<AdMediaPage>(`businesses/${businessID}/ad-media`, {
      params: { mediaType, search: search || undefined, offset },
    })
    return response.data
  },
  deleteImage: async imageID => {
    await NestAPI.delete(`businesses/${businessID}/ad-images/${imageID}`)
  },
})
